export const questHide = () => {
    const tabButtons = document.querySelectorAll('.quest-btn');
    const tabPanes = document.querySelectorAll('.quest-pane');

    if (!tabButtons.length || !tabPanes.length) return;

    const movePaneAfterBtn = (btn, pane) => {
        if (btn && pane && document.body.contains(pane)) {
            btn.insertAdjacentElement('afterend', pane);
        }
    };

    const initialBtn = document.querySelector('.quest-btn.active');
    const initialPane = document.querySelector('.quest-pane.active');
    if (initialBtn && initialPane) {
        movePaneAfterBtn(initialBtn, initialPane);
    }

    tabButtons.forEach((btn) => {
        btn.addEventListener('click', () => {
            const targetId = btn.dataset.tab;
            const targetPane = document.getElementById(targetId);

            if (!targetPane) return;

            // Повторный клик по активному табу — закрываем
            if (btn.classList.contains('active')) {
                btn.classList.remove('active');
                targetPane.classList.remove('active');
                return;
            }

            tabButtons.forEach((b) => b.classList.remove('active'));
            tabPanes.forEach((pane) => pane.classList.remove('active'));

            btn.classList.add('active');
            targetPane.classList.add('active');

            movePaneAfterBtn(btn, targetPane);
        });
    });
};
